export default {
  title: 'Tryb zajętości',
  form: {
    has_busy_mode: {
      label: 'Tryb zajętości',
    },
    busy_mode_minutes: {
      label: 'O ile czasu dodać do standardowego czasu przygotowania?',
      options: {
        10: '10 min',
        15: '15 min',
        20: '20 min',
        25: '25 min',
        30: '30 min',
        45: '45 min',
        60: '1 godz.',
      },
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zapisane pomyślnie',
  },
};
